/* istanbul ignore file */
import React from 'react'
import * as blueprint from '@adc/blueprint'
import ScrollSpy from '../../../layouts/scrollspy'

export class WinningBidDepositBadge extends blueprint.listing.badges
  .WinningBidDepositBadge {
  get tooltipContent() {
    return (
      <div>
        <ScrollSpy selector='#prepare_your_finances'>
          {({ scrollTo }) => (
            <>
              A Winning Bid Deposit is required for each property you
              successfully bid on and must be paid upon being declared the
              winning bidder. Further action will be required to submit the
              remaining balance.{' '}
              <a
                onClick={scrollTo}
                data-elm-id='winning_bid_deposit_badge_tooltip-content'
              >
                Learn more
              </a>
            </>
          )}
        </ScrollSpy>
      </div>
    )
  }
}
